import { render, staticRenderFns } from "./UpdateKnowledge.vue?vue&type=template&id=4c78efa6&scoped=true"
import script from "./UpdateKnowledge.vue?vue&type=script&lang=js"
export * from "./UpdateKnowledge.vue?vue&type=script&lang=js"
import style0 from "./UpdateKnowledge.vue?vue&type=style&index=0&id=4c78efa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c78efa6",
  null
  
)

export default component.exports